import { ClipboardIcon } from '@heroicons/react/24/outline'
import { useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { FormattedMessage } from 'react-intl'

import { Copy } from '@/components/Icons'
import Button from '@/components/TailwindUI/Button'

import messages from './messages'

const CopyTextButton = ({ text }: { text: string }) => {
  const [hasBeenCopied, setHasBeenCopied] = useState(false)

  const delayTextSwitch = () => {
    setTimeout(() => {
      setHasBeenCopied(false)
    }, 2000)
  }

  return (
    <CopyToClipboard
      text={text}
      onCopy={() => {
        if (!hasBeenCopied) {
          setHasBeenCopied(true)
          delayTextSwitch()
        }
      }}
    >
      <div className="copy-to-clipboard">
        <Copy />
        {hasBeenCopied ? <FormattedMessage {...messages.copied} /> : <FormattedMessage {...messages.copy} />}
      </div>
    </CopyToClipboard>
  )
}

export default CopyTextButton

/**
 * 2024 standard for a button that copies text to the clipboard
 */
export const CopyButton = ({ text }: { text: string }) => {
  const [hasBeenCopied, setHasBeenCopied] = useState(false)
  const delayTextSwitch = () => {
    setTimeout(() => {
      setHasBeenCopied(false)
    }, 2000)
  }
  return (
    <CopyToClipboard
      text={text}
      onCopy={() => {
        if (!hasBeenCopied) {
          setHasBeenCopied(true)
          delayTextSwitch()
        }
      }}
    >
      <Button className="row max-w-[90px] bg-white font-semibold text-brand-400 shadow-sm ring-1 ring-inset ring-brand-400/50 hover:bg-brand-100">
        <ClipboardIcon className="mr-2 h-5 w-5" />
        {hasBeenCopied ? <FormattedMessage {...messages.copied} /> : <FormattedMessage {...messages.copy} />}
      </Button>
    </CopyToClipboard>
  )
}
